var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnBreak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1022",
    "data-name": "Ellipse 1022",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#f5b65e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBreak);
export default __webpack_public_path__ + "static/media/onBreak.ecdea000aa16e1547f0dc5c59233a022.svg";
export { ForwardRef as ReactComponent };